import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/gaia-material',
    component: () => import('@/views/material/index.vue'),
    children: [
      {
        path: 'list',
        component: () => import('@/views/material/list.vue')
      },
      {
        path: 'detail/:id',
        component: () => import('@/views/material/detail.vue')
      },
      {
        path: 'video-upload',
        component: () => import('@/views/material/upload/video-upload.vue')
      },
      {
        path: 'picture-upload',
        component: () => import('@/views/material/upload/picture-upload.vue')
      },
      {
        path: 'music-upload',
        component: () => import('@/views/material/upload/music-upload.vue')
      },
      {
        path: 'template-upload',
        component: () => import('@/views/material/upload/template-upload.vue')
      },
      {
        path: 'virtual-upload',
        component: () => import('@/views/material/upload/virtual-upload.vue')
      },
      {
        path: 'other-upload',
        component: () => import('@/views/material/upload/other-upload.vue')
      },
      {
        path: 'check-verified',
        component: () => import('@/views/material/checkVerified.vue')
      },
      {
        path: 'video-update',
        component: () => import('@/views/material/update/video-update.vue')
      },
      {
        path: 'music-update',
        component: () => import('@/views/material/update/music-update.vue')
      },
      {
        path: 'picture-update',
        component: () => import('@/views/material/update/picture-update.vue')
      },
      {
        path: 'template-update',
        component: () => import('@/views/material/update/template-update.vue')
      },
      {
        path: 'virtual-update',
        component: () => import('@/views/material/update/virtual-update.vue')
      },
      {
        path: 'other-update',
        component: () => import('@/views/material/update/other-update.vue')
      }
    ]
  },
  {
    path: '/gaia-48',
    component: () => import('@/views/gaia48/index.vue'),
    children: [
      {
        path: 'main',
        component: () => import('@/views/gaia48/gaia48.vue')
      },
      {
        path: 'update',
        component: () => import('@/views/gaia48/update.vue')
      },
      {
        path: 'upload',
        component: () => import('@/views/gaia48/upload.vue')
      },
      {
        path: 'info',
        component: () => import('@/views/gaia48/richView.vue')
      },
      {
        path: 'introduce',
        component: () => import('@/views/gaia48/richView.vue')
      },
      {
        path: 'party-night',
        component: () => import('@/views/gaia48/richView.vue')
      },
      {
        path: 'news',
        component: () => import('@/views/gaia48/richView.vue')
      },
      {
        path: 'exhibit-year',
        component: () => import('@/views/gaia48/exhibit-year.vue')
      },
      {
        path: 'exhibit-region',
        component: () => import('@/views/gaia48/exhibit-region.vue')
      },
      {
        path: 'detail',
        component: () => import('@/views/gaia48/detail.vue')
      },
      {
        path: 'download',
        component: () => import('@/views/gaia48/download.vue')
      }
    ]
  },
  {
    path: '/shopping-cart',
    component: () => import('@/views/shopping-cart.vue'),
  },
  {
    path: '/center/:id',
    component: () => import('@/views/center/center.vue'),
  },
  {
    path: '/center-manage',
    component: () => import('@/views/center/auditList.vue'),
  },
  {
    path: '/about',
    component: () => import('@/views/about.vue'),
  },
  {
    path: '/richPage',
    component: () => import('@/views/richPage.vue'),
  },
  {
    path: '/foot-page',
    component: () => import('@/components/gaia-footer/gaia-footer.vue'),
  },
  {
    path: '/group-add',
    component: () => import('@/views/center/group-add.vue'),
  },
  {
    path: '*',
    component: () => import('@/views/404.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: "/desktop/",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
